import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SidebarHeaderProps } from './types';

export function SidebarHeader({
  isCollapsed,
  onToggleCollapse,
  onClose,
  isMobile = false,
}: SidebarHeaderProps) {
  const { t } = useTranslation('layout');
  return (
    <div className="relative p-4 flex items-center justify-between border-b border-blue-800">
      {!isCollapsed && (
        <div className="flex items-center">
          <a href="/">
            <span className="font-bold text-white">Someaknea Tech</span>
          </a>
        </div>
      )}
      {isCollapsed && (
        <div className="flex items-center">
          <a href="/">
            <span className="font-extrabold text-white text-base">ST</span>
          </a>
        </div>
      )}
      {isMobile ? (
        <Button
          onClick={onClose}
          variant="outline"
          size="icon"
          className="bg-white rounded-full p-1 shadow-md text-blue-800 hover:bg-gray-100 h-6 w-6 z-50"
          aria-label={t('sidebar.closeSidebar')}
        >
          <ChevronLeft size={14} />
        </Button>
      ) : (
        <Button
          onClick={onToggleCollapse}
          variant="outline"
          size="icon"
          className="absolute -right-3 top-6 bg-white rounded-full p-1 shadow-md text-blue-800 hover:bg-gray-100 h-6 w-6 z-50"
          aria-label={isCollapsed ? t('sidebar.expandSidebar') : t('sidebar.collapseSidebar')}
        >
          {isCollapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
        </Button>
      )}
    </div>
  );
}
